import { render, staticRenderFns } from "./inventoryGlassSizeProjectionWidget.vue?vue&type=template&id=30e23a6f&"
import script from "./inventoryGlassSizeProjectionWidget.vue?vue&type=script&lang=js&"
export * from "./inventoryGlassSizeProjectionWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports